import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { RedatedParams } from '@api/order-reporting/types/RedatedParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingRedated.gridData;
export const selectDateRange = (state: RootState) => state.reportingRedated.dateRange;
export const selectSelectedPlant = (state: RootState) => state.reportingRedated.selectedPlant;
export const selectFilterDate = (state: RootState) => state.reportingRedated.filterDate;



export const selectValidParams = createSelector(
	[
		selectDateRange,
		selectSelectedPlant,
		selectFilterDate,
	],(
		dateRange: DateRange | null,
		selectedPlant: string | null,
		filterDate: string | null,
	) => {
		if (!dateRange) return null;
		let validParams: RedatedParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
			...(selectedPlant && { dc: selectedPlant }),
			...(filterDate && { filterDate: filterDate }),
		};
		return validParams;
	}
);